import React from 'react';
import {
	ProfileContainer,
	ProfilePreferencesSmallLegend
} from '~/modules/components/global/preferences/preferences.css';
import SelectMenu from '~/modules/components/global/select';
import PropTypes from 'prop-types';
import Icon from '~/modules/components/global/icon';

const ProfilePreferences = ({
	preferences, handlePreferencesChange, session, setUser, user, territoriesOptions
}) => (
	<ProfileContainer data-testid="preferences-profile">
		<fieldset>
			<legend className="h5" style={{ display: 'flex', alignItems: 'center' }}>
				Two Factor Authentication
				<input
					type="checkbox"
					name="enableTwoFactor"
					id="enableTwoFactor"
					checked={user?.hasEnforced2fa || preferences.twofactor?.enabled}
					disabled={user?.hasEnforced2fa}
					onChange={(e) => handlePreferencesChange('twofactor', 'enabled', e.target.checked)}
				/>
				{user?.hasEnforced2fa
					? <ProfilePreferencesSmallLegend>
						<Icon use="warning" color={'silver-base'}/>&nbsp;
						Two Factor Authentication is enforced by your organization
					</ProfilePreferencesSmallLegend>
					: ''}
			</legend>
			<legend className="h6">
				<label>Name</label>
				<input
					type="text"
					name="name"
					id="name"
					data-testid="preferences-profile-name-input"
					value={session.name}
					disabled
				/>
			</legend>
			<legend className="h6">
				<label>Email Address</label>
				<input
					type="text"
					name="name"
					id="name"
					data-testid="preferences-profile-name-input"
					value={session.emailNormal}
					disabled
				/>
			</legend>
			<legend className="h6">
				<label>Territory</label>
				<SelectMenu
					className="territory-preference"
					options={territoriesOptions}
					value={territoriesOptions.find((o) => o.value === user.territory?._id)}
					onChange={(territory) => setUser({
						...user,
						territory: { name: territory.name, _id: territory.value }
					}) }
					maxMenuHeight={200}
				/>
			</legend>
		</fieldset>
	</ProfileContainer>

);

ProfilePreferences.propTypes = {
	session: PropTypes.object,
	user: PropTypes.object,
	preferences: PropTypes.object,
	territoriesOptions: PropTypes.array,
	handlePreferencesChange: PropTypes.func,
	setUser: PropTypes.func
};
export default ProfilePreferences;
